// DOC REF
// https://blog.devgenius.io/file-upload-with-progress-bar-in-angular-13-76adb3380f18
import { HttpEvent, HttpEventType } from '@angular/common/http';
import { Response } from '@models/response-api/ResponseApi';

export class Progress {
  static handleProgress(event: HttpEvent<Response>) : [boolean, number, Response?] {
    if (event.type === HttpEventType.UploadProgress) {
      const progress = Math.round((100 * event.loaded) / event.total!);
      return [false, progress];
    } else if (event.type === HttpEventType.Response) {
      const data = event?.body as Response;
      return [true, 100, data];
    } else {
      return [false, 0];
    }
  }
}